"use strict";
exports.__esModule = true;
exports.LinkType = void 0;
var LinkType;
(function (LinkType) {
    LinkType["Web"] = "link-web";
    LinkType["Document"] = "link-document";
    LinkType["Media"] = "link-media";
})(LinkType = exports.LinkType || (exports.LinkType = {}));
//# sourceMappingURL=link.js.map